import { cartStore } from '@stores/cart';

/**
 * Hook spécialisé pour le Header - sélectionne uniquement les données nécessaires
 * pour éviter les re-renders inutiles du Header lors des changements du cart
 */
export function useCartHeader() {
    // Sélecteurs individuels pour éviter la création d'objets à chaque render
    const hasItems = cartStore((state) => !!state.byouCart?.gencode);
    const itemsCount = cartStore((state) => state.byouCart?.itemsCount ?? 0);

    return { hasItems, itemsCount };
}
